"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var caption_1 = require("./caption");
var paragraph_1 = require("./paragraph");
var subtitle_1 = __importDefault(require("./subtitle"));
var title_1 = __importDefault(require("./title"));
var LftTypography = function (_a) {
    var bgColor = _a.bgColor, children = _a.children, component = _a.component, dataTestId = _a.dataTestId, fontWeight = _a.fontWeight, _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.pre, pre = _c === void 0 ? false : _c, variant = _a.variant;
    switch (component) {
        case 'caption':
            return ((0, jsx_runtime_1.jsx)(caption_1.CaptionParagraphStyled, __assign({ "data-lift": "lft-typography" }, { children: (0, jsx_runtime_1.jsx)(caption_1.CaptionStyled, __assign({ bgColor: bgColor, "data-lift": "lft-typography-caption", "data-testid": dataTestId, fontWeight: fontWeight, size: size }, { children: children }), void 0) }), void 0));
        case 'paragraph':
            if (!pre) {
                return ((0, jsx_runtime_1.jsx)(paragraph_1.ParagraphStyled, __assign({ bgColor: bgColor, "data-lift": "lft-typography-paragraph", "data-testid": dataTestId, fontWeight: fontWeight, size: size }, { children: children }), void 0));
            }
            else {
                return ((0, jsx_runtime_1.jsx)(paragraph_1.ParagraphPreStyled, __assign({ bgColor: bgColor, "data-lift": "lft-typography-paragraph", "data-testid": dataTestId, fontWeight: fontWeight, size: size }, { children: children }), void 0));
            }
        case 'subtitle':
            return ((0, jsx_runtime_1.jsx)(subtitle_1.default, __assign({ bgColor: bgColor, "data-lift": "lft-typography-subtitle", "data-testid": dataTestId, fontWeight: fontWeight, size: size }, { children: children }), void 0));
        case 'title':
            return ((0, jsx_runtime_1.jsx)(title_1.default, __assign({ bgColor: bgColor, dataTestId: dataTestId, fontWeight: fontWeight, size: size, variant: variant }, { children: children }), void 0));
        default:
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0);
    }
};
exports.default = LftTypography;
